import v1resetErrors from '../../actions/errors/v1resetErrors'
import { V1_REQUEST_SEAT_TRADE } from '../../actions/seatTrade/v1requestSeatTrade'
import { V1_SET_USER_HAS_CUSTOM_TOUR_OPERATOR_OVERWRITE } from '../../actions/users/v1setUserHasCustomTourOperatorOverwrite'

/**
 * List of actions that need to trigger the generic errors
 * to be reset. Every action here will be one that we created
 * ourselves. Exceptions to this rule should be documented
 * below.
 *
 * Hook into the react-router action when a route in changed
 * and reset our generic errors when it does.Currently react
 * router fires the following event type when the page has
 * changed:
 * '@@router/LOCATION_CHANGE'
 */
const actionsToResetErrors = [
  '@@router/LOCATION_CHANGE',
  V1_REQUEST_SEAT_TRADE,
  V1_SET_USER_HAS_CUSTOM_TOUR_OPERATOR_OVERWRITE,
]

export default ({ dispatch }) => next => async action => {
  next(action)

  if (!actionsToResetErrors.includes(action.type)) return

  dispatch(v1resetErrors())
}
